import { cva } from "class-variance-authority";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { Icon } from "@/components/common/icon";

const variants = cva(
  [
    "relative",
    "cursor-text",
    "disabled:cursor-not-allowed",
    "outline-none",
    "border-solid",
    "border",
    "placeholder-neutral-400",
    "text-neutral-900",
    "border-neutral-300",
    "hover:border-neutral-400",
    "tracking-wide",
    "text-sm",
    "transition",
    "active:border-primary-500",
    "focus:border-primary-500",
  ],
  {
    variants: {
      variant: {
        primary: [],
      },
      size: {
        small: ["py-2", "px-5", "rounded-full"],
        default: ["py-2", "px-5", "rounded-lg"],
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);

function Input({
  variant,
  size,
  placeholder,
  faIconLeft,
  faIconRight,
  className,
  ...rest
}) {
  return (
    <div className="flex items-center relative">
      <input
        className={twMerge(
          clsx(variants({ variant, size, className }), "peer", {
            "pl-10": faIconLeft,
            "pr-10": faIconRight,
          }),
        )}
        placeholder={placeholder}
        type="text"
        {...rest}
      />

      {faIconLeft ? (
        <Icon
          className="absolute left-0 ml-3 w-4 h-4 z-10 text-neutral-300 transition peer-active:text-neutral-900 peer-focus:text-neutral-900 peer-hover:text-neutral-900"
          faIcon={faIconLeft}
        />
      ) : null}

      {faIconRight ? (
        <Icon
          className="absolute right-0 mr-3 w-4 h-4 z-10 text-neutral-300 transition peer-active:text-neutral-900 peer-focus:text-neutral-900 peer-hover:text-neutral-900"
          faIcon={faIconRight}
        />
      ) : null}
    </div>
  );
}

export { Input };
